import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import { translate, isNullOrEmpty, showMessageToastCustom, enumText } from '../../../../../utils/util';
import * as pabReplanningAction from '../../../../../actions/pabReplanningAction';
import { ENUMS } from '../../../../../utils/constants';
import PabReplanningService from '../../../../../services/PABReplanningService';

const SmallPartsFilterByOrder = (props) => {
    const [orderCode, setOrderCode] = useState('');
    let inputFilter;

    useEffect(() => {
        inputFilter.focus();
    }, [inputFilter]);

    const applyFilter = () => {
        if (!isNullOrEmpty(orderCode)) {
            props.filter.orderCode = orderCode;
            props.filter.status = null;
            props.setFilterOrder(props.filter);
            props.getOrders(props.filter, {
                PageSize: 25,
                PageIndex: 0
            }, (response) => {
                const selectedItem = response.items ? response.items[0] : null;
                if (selectedItem) {
                    if (selectedItem.status === ENUMS.eOrderStatus.Canceled.value || selectedItem.status === ENUMS.eOrderStatus.Finished.value || selectedItem.status === ENUMS.eOrderStatus.ManuallyFinished.value) {
                        return showMessageToastCustom(translate('general:warning'),
                            `O pedido está ${enumText(ENUMS.eOrderPabStatus, selectedItem.status)} `, 8000, 'mdi mdi-alert-circle-outline orange-text');
                    }
                    props.setSelectedOrder(selectedItem);
                    return props.history.push({
                        pathname: `../order/details`
                    });
                }
            });
        }
    };

    const subtitlesPickingFilterByOrder = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filterByOrder') }];
    }

    return (
        <div>
            <Breadcrumbs id="pickingFilterByOrder" subtitles={subtitlesPickingFilterByOrder()} />
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="col s12">
                        <input
                            id="txtOrder"
                            ref={(el) => inputFilter = el}
                            placeholder={translate('expedition:picking.order')}
                            type="number"
                            onChange={(event) => { setOrderCode(event.currentTarget.value); }}
                            maxLength="20"
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <button
                        type="button"
                        className="col s12 m3
                        btn
                        btn-principal
                        waves-effect
                        waves-light"
                        onClick={() => applyFilter()}
                    >
                        {translate('apply', 'general')}
                    </button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.pabReplanningReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterOrder: (filter) => {
            dispatch(pabReplanningAction.setFilter(filter));
        },
        setSelectedOrder: (order) => {
            dispatch(pabReplanningAction.selectOrder(order));
        },
        getOrders: (filter, pagination, callback) => {
            dispatch(PabReplanningService.getOrders(filter, pagination, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallPartsFilterByOrder)));
